var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"track-overview"},[_c('el-row',{staticClass:"container-card el-row"},[_c('TrackOverview')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }